import React, {ReactElement} from 'react';

// eslint-disable-next-line no-irregular-whitespace
const RequiredFieldAsterisk = (): ReactElement => <span aria-hidden="true" className="MuiFormLabel-asterisk MuiInputLabel-asterisk">*</span>;
export default RequiredFieldAsterisk;